import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=0a1fb18f&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=0a1fb18f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1fb18f",
  null
  
)

export default component.exports